import {omneticApi} from '@dms/api/base';

import {CreatePriceReportRequestApiResponse, CreatePriceReportRequestApiArg} from './types';

export const fastPricingApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    createEmptyPriceReportRequest: build.mutation<
      CreatePriceReportRequestApiResponse,
      CreatePriceReportRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/fast-pricing/price-report-request`,
        method: 'POST',
        body: queryArg.createPriceReportRequestRequestBody,
      }),
    }),
  }),
});

export const {useCreateEmptyPriceReportRequestMutation} = fastPricingApi;
